import { Grid } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import globalProfileStyle from '../../Styles/ComponentStyles/ProfileStyle/Profile.module.scss'
import { ProfileContext, ProfileContextPayload } from '../../Context/ProfileDetailsContext'
import { UserContext, UserContextPayload } from '../../Context/UserDetailContext'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import GlobalPopUp from '../../GlobalComponent/GlobalPopup/GlobalPopup'
import RegisterProfile from '../../GlobalComponent/RegisterProfile/RegisterProfile'
import { useSnackbar } from '../../GlobalComponent/GlobalSnackbar/GlobalSnackbar'
import GlobalTabsComponent from '../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent'

interface AgentOption {
    user_id: number
    user_firstname: string
    user_lastname: string
    user_role_type?: string
}

const Profile = () => {
    const {
        flagOpenRegisterProfileDialog,
        setFlagOpenRegisterProfileDialog,
        getAgentProfileDetails,
    } = useContext(ProfileContext) as ProfileContextPayload

    const {
        userDetail,
        setFlagLoader
    } = useContext(UserContext) as UserContextPayload

    const { showSnackbar } = useSnackbar()
    const location = useLocation()
    const navigate = useNavigate()

    const [profileType, setProfileType] = useState('all')
    const [agentOptions, setAgentOptions] = useState<AgentOption[]>([])
    const [selectedAgent, setSelectedAgent] = useState<AgentOption | null>(null)

    const userRole = userDetail?.user_data?.user_role_type?.toLowerCase()

    useEffect(() => {
        if (location?.pathname?.toLowerCase() === "/profile/annuityprofiles") {
            setProfileType("annuity")
        } else if (location?.pathname?.toLowerCase() === "/profile/iulprofiles") {
            setProfileType("iul")
        } else if (location?.pathname?.toLowerCase() === "/profile/allprofiles") {
            setProfileType("all")
        } else {
            setProfileType("all")
        }
    }, [location?.pathname])

    useEffect(() => {
        const fetchAgentDetails = async () => {
            try {
                setFlagLoader(true)

                if (userRole !== 'agent') {
                    const response = await getAgentProfileDetails()

                    if (response?.status) {
                        if (response?.data) {
                            const filterAgents = response?.data[0].agents.filter(
                                (roleType) => roleType.user_role_type.toLowerCase() !== "admin"
                            )
                            setAgentOptions(filterAgents)
                        }
                    } else {
                        const errorMessage = response?.data?.error?.message || 'Something Went Wrong!'
                        showSnackbar(errorMessage, 'error')
                    }
                }
            } catch (error) {
                console.log(error, "Error fetching agent details")
                showSnackbar('Failed to fetch agent details', 'error')
            } finally {
                setFlagLoader(false)
            }
        }

        if (userRole) {
            fetchAgentDetails()
        }
    }, [userRole])

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setProfileType(newValue)
        setSelectedAgent(null)

        switch (newValue) {
            case 'all':
                navigate(`/profile/allProfiles`)
                break
            case 'iul':
                navigate(`/profile/iulProfiles`)
                break
            case 'annuity':
                navigate(`/profile/annuityProfiles`)
                break
        }
    }

    const handleAgentChange = (_event: React.SyntheticEvent<Element, Event>, newValue: AgentOption | null) => {
        setSelectedAgent(newValue)
    }

    return (
        <>
            {flagOpenRegisterProfileDialog && (
                <GlobalPopUp
                    open={flagOpenRegisterProfileDialog}
                    onClose={() => { setFlagOpenRegisterProfileDialog(false) }}
                    title='Create New Profile'
                    showCloseIcon={true}
                    maxWidth="sm"
                >
                    <RegisterProfile />
                </GlobalPopUp>
            )}

            <Grid container gap={3}>
                <Grid item xs={12}
                    sx={{
                        backgroundColor: "#fff",
                        padding: "0px 20px",
                        borderBottom: "1px solid #E2E8F0"
                    }}
                >
                    <GlobalTabsComponent
                        value={profileType}
                        onChange={handleTabChange}
                        normalColor="#45556C"
                        selectedColor="#04385D"
                        indicatorColor="#04385D"
                        tabs={[
                            { label: "All Profiles", value: "all" },
                            { label: "IUL Profiles", value: "iul" },
                            { label: "Annuity Profiles", value: "annuity" },
                        ]}
                    />
                </Grid>
                <Grid item xs={12} className={`${globalProfileStyle.globalProfileOutletItem}`}>
                    <Outlet context={{
                        agentOptions,
                        selectedAgent,
                        handleAgentChange
                    }} />
                </Grid>

            </Grid >
        </>
    )
}

export default Profile